import * as React from "react";
const Grey = (props) => (
  <svg
    width={200}
    height={47}
    viewBox="0 0 258 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M257.626 0C222.828 29.3276 177.884 47 128.813 47C79.7417 47 34.7983 29.3276 0 0H257.626Z"
      fill="#4B4B4B"
    />
  </svg>
);
export default Grey;
